import { Component } from '@ecs/Component';
import type { PlayerShipClass } from '@entities/PlayerShips';

export class ShipClass implements Component {
  readonly type = 'ShipClass';

  constructor(
    public value: PlayerShipClass
  ) {}
}
